<template>
  <portal-layout>
    <div class="report-page">
      <div class="page-head">
        <h2 class="page-title">学习报告</h2>
        <div v-if="students.length > 0" class="student-select">
          <span class="select-label">小主：</span>
          <el-select v-model="studentIndex" size="small" class="select-input"
                     @change="loadStudyPlans">
            <el-option v-for="(stu, index) in students" :key="stu.id"
                       :label="stu.name" :value="index"></el-option>
          </el-select>
        </div>
      </div>

      <div v-loading="loading" class="plan-list">
        <div v-if="!loading && studyPlans.length === 0" class="empty-tip">
          {{ students.length === 0 ? '请先在个人中心添加小主档案' : '暂无学习计划' }}
        </div>

        <div v-for="plan in studyPlans" :key="plan.id" class="plan-card" @click="goDetail(plan)">
          <div class="plan-header">
            <div class="plan-course">{{ plan.courseName }}</div>
            <el-tag size="mini" :type="plan.teachingFormat === 'live' ? 'danger' : ''" effect="plain">
              {{ plan.teachingFormat === 'live' ? '直播' : '录播' }}
            </el-tag>
          </div>
          <div class="plan-info">
            <div class="info-item">
              <i class="el-icon-collection-tag"></i>
              <span>{{ plan.cateName }}<template v-if="plan.commodityTitle">（{{ plan.commodityTitle }}）</template></span>
            </div>
            <div class="info-item" v-if="plan.fitGrade">
              <i class="el-icon-user"></i>
              <span>适合{{ plan.fitGrade }}</span>
            </div>
            <div class="info-item">
              <i class="el-icon-video-camera"></i>
              <span>共 {{ plan.courseNum }} 节课<template v-if="plan.videoMainTitle">（{{ plan.videoMainTitle }}）</template></span>
            </div>
          </div>
          <div class="plan-footer">
            <span class="view-detail">查看详情 <i class="el-icon-arrow-right"></i></span>
          </div>
        </div>
      </div>
    </div>
  </portal-layout>
</template>
<script>
import PortalLayout from '@/components/PortalLayout.vue';
import api from '@/common/api';
import storage from '@/common/storage.js';

export default {
  name: 'PortalReportList',
  components: { PortalLayout },
  data() {
    return {
      loading: false,
      students: [],
      studentIndex: 0,
      studyPlans: []
    }
  },
  created() {
    if (!this.checkLogin()) {
      return;
    }
    this.loadStudents();
  },
  methods: {
    checkLogin() {
      if (!storage.getString('portalMember')) {
        if (this.$route.name === 'PortalLogin') return false;
        this.$router.push({ name: 'PortalLogin', query: { redirect: this.$route.fullPath } }).catch(() => {});
        return false;
      }
      return true;
    },
    loadStudents() {
      this.loading = true;
      api.student_list().then((r) => {
        if (r.data.code === "200") {
          // R.ok(List) 走 rows
          this.students = r.data.rows || [];
          if (this.students.length > 0) {
            this.studentIndex = 0;
            this.loadStudyPlans();
          } else {
            this.studyPlans = [];
            this.loading = false;
          }
        } else {
          this.loading = false;
        }
      }).catch(() => {
        // 401 已由 common/api.js 统一跳转登录页
        this.loading = false;
      });
    },
    loadStudyPlans() {
      const stu = this.students[this.studentIndex];
      if (!stu) {
        this.studyPlans = [];
        return;
      }
      this.loading = true;
      api.report({ studentId: stu.id }).then((r) => {
        if (r.data.code === "200") {
          // 后端 R.ok(page) 走 data 字段，返回 MyBatis-Plus 分页对象
          const page = r.data.data || {};
          this.studyPlans = page.records || [];
        }
      }).catch(() => {}).finally(() => {
        this.loading = false;
      });
    },
    goDetail(plan) {
      this.$router.push('/portal/report/detail?id=' + plan.id).catch(() => {});
    }
  }
};
</script>
<style scoped>
.page-head {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}
.page-title {
  font-size: 22px;
  color: #303133;
  margin: 0;
}
.student-select {
  display: flex;
  align-items: center;
}
.select-label {
  font-size: 14px;
  color: #606266;
  margin-right: 8px;
}
.select-input {
  width: 160px;
}
.plan-list {
  min-height: 200px;
}
.plan-card {
  background-color: #fff;
  border-radius: 8px;
  padding: 20px 25px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  margin-bottom: 15px;
  cursor: pointer;
  transition: all 0.3s;
}
.plan-card:hover {
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
}
.plan-header {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 15px;
}
.plan-course {
  font-size: 17px;
  color: #303133;
  font-weight: 500;
}
.plan-info {
  display: flex;
  flex-wrap: wrap;
  gap: 25px;
}
.info-item {
  font-size: 13px;
  color: #606266;
}
.info-item i {
  color: #409EFF;
  margin-right: 6px;
}
.plan-footer {
  margin-top: 15px;
  padding-top: 15px;
  border-top: 1px solid #ebeef5;
  text-align: right;
}
.view-detail {
  font-size: 13px;
  color: #409EFF;
}
.empty-tip {
  text-align: center;
  color: #909399;
  padding: 60px 0;
  font-size: 14px;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}
</style>
